export default "__VITE_ASSET__L3jkBtFz__"